angular.module('assets')
    .factory('AssetSettingsLoader', function ($q, Asset, Project) {
        let _loading = false;
        let _isCurrentUserSupervisor = undefined;

        let _userProjectsMember;
        let _userProjectsPromise;

        function isSupervisor(force) {
            if(force){
                _isCurrentUserSupervisor = undefined;
            }
            let $p = $q.defer();

            if (_isCurrentUserSupervisor !== undefined && _loading === false) {
                $p.resolve(_isCurrentUserSupervisor);
                return $p.promise;
            }

            _loading = true;
            Asset.isSupervisor().$promise.then(result => {
                _loading = false;
                _isCurrentUserSupervisor = (result.isSupervisor === true);
                $p.resolve(_isCurrentUserSupervisor);
            });
            return $p.promise;
        }

        function isMemberOf(projectId) {
            let $p = $q.defer();
            if(_userProjectsMember !== undefined){
                $p.resolve(checkIfProjectInList(projectId));
                return $p.promise;
            }

            if(_userProjectsPromise){
                _userProjectsPromise.then(() => {
                    $p.resolve(checkIfProjectInList(projectId));
                });
            }
            else{
                _userProjectsPromise = Project.autocomplete({ userProjectsFilter: true }).$promise;
                _userProjectsPromise.then(items => {
                    _userProjectsMember = items;
                    $p.resolve(checkIfProjectInList(projectId))
                });
            }
            return $p.promise;
        }

        function checkIfProjectInList(projectId) {
            let projects = _userProjectsMember.filter(i => i.id === projectId);
            return projects.length > 0;
        }

        function isSupervisorResolved() {
            return _isCurrentUserSupervisor !== undefined;
        }

        return {
            isSupervisor: isSupervisor,
            isSupervisorResolved: isSupervisorResolved,
            isMemberOf: isMemberOf
        };
    })
